import { LitElement, html, css } from 'lit';
import { customElement } from '../customElement';
import { css as icons } from '../icons/fontAwesome';

@customElement('copy-text')
export class CopyText extends LitElement {

	static styles = css`
	.flex {display: flex;}
	.padded {
		padding: 10px;
		color: darkcyan;
		border: solid 1px darkcyan;
		border-top-left-radius: 15px;
		border-bottom-left-radius: 15px;
	}
	.button-container {
		border-top: 1px solid darkcyan;
		border-bottom: 1px solid darkcyan;
		border-right: 1px solid darkcyan;
		padding: 10px;
		border-top-right-radius: 15px;
		border-bottom-right-radius: 15px;
	}
	.hover {cursor: pointer;}
	i {font-size:20px;}
	${icons}`;

	get slottedChildren() {
		const slot = this.shadowRoot.querySelector('slot');
		return slot.assignedElements();
	}

	copy(e: MouseEvent) {
		const text = this.slottedChildren[0]?.textContent ?? '';
		navigator.clipboard.writeText(text.trim());

		//Create an event and transmit it to indicate the text has been copied
		const event = new CustomEvent('textcopied', { bubbles: true, cancelable: false, detail: text.trim(), composed: true });
		this.dispatchEvent(event);
	}

	render() {
		return html`
		<div class="flex container">
			<div class="padded">
				<slot></slot>
			</div>
			<div class="button-container">
				<a class="hover" @click=${this.copy}><i class="fas fa-copy"></i></a>
			</div>
		</div>
		`;
	}
}